import { createFeatureSelector, createSelector } from '@ngrx/store';
import { get as _get } from 'lodash';

import { ClaimPhotoSummary } from './photo-upload.model';
import { adapter, PHOTOUPLOAD_FEATURE_KEY, PhotoUploadState } from './photo-upload.reducer';

// Lookup the 'PhotoUpload' feature state managed by NgRx
const getPhotoUploadState = createFeatureSelector<PhotoUploadState>(PHOTOUPLOAD_FEATURE_KEY);

// Get selectors
const { selectAll, selectEntities, selectIds } = adapter.getSelectors();

export const getClaimPhotoEntities = createSelector(getPhotoUploadState, selectEntities);

export const getClaimPhotoIds = createSelector(getPhotoUploadState, selectIds);

export const getClaimPhotos = createSelector(getPhotoUploadState, selectAll);

export const getClaimPhotosSummaries = createSelector(getClaimPhotos, claimPhotos => {
  console.log(claimPhotos);
  const photoSummaryList: ClaimPhotoSummary[] = [];
  claimPhotos.forEach(photo => {
    const photoSummary: ClaimPhotoSummary = {
      url: _get(photo, 'links.href'),
      category: photo.metaData.find(data => data.name === 'Document Title').value,
      description: photo.metaData.find(data => data.name === 'Content Description').value,
      dateCreated: photo.metaData.find(data => data.name === 'Date Created').value
    };
    photoSummaryList.push(photoSummary);
  });
  return photoSummaryList;
});

export const photoUploadQuery = {
  getClaimPhotoEntities,
  getClaimPhotoIds,
  getClaimPhotos,
  getClaimPhotosSummaries
};
